/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentContext {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentContext.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentContext>): WellArchitectedFrameworkAssessmentContext {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentContext(), model);
        WellArchitectedFrameworkAssessmentContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentContext>): WellArchitectedFrameworkAssessmentContext {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentContext.newInstance(<WellArchitectedFrameworkAssessmentContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentContext) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentContext): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the Framework. This can be retrieved using the Well Architected Framework List API.
     */
    framework_id: string;

    /**
     * ID of the Pillar associated with the Framework
     */
    pillar_id: string;

    /**
     * ID of the Question associated with the Pillar
     */
    question_id: string;

    /**
     * ID of the Bestpractice associated with the Question
     */
    best_practice_id: string;

}
